import React from "react";

/**
 * ProductPreview — an affiliate Shop product in the recommendation rail.
 *
 * Products are NOT listings: they come from a different retrieval source (the shop
 * catalogue, not the member directory) and lead to a purchase, not an enquiry. The card
 * says so plainly — "The LWD Shop" label, no Aura Score, no Enquire — so a couple is
 * never left thinking a Jimmy Choo pump is a vendor we represent.
 *
 * Every value shown comes from the product record: brand, style, price, feed image.
 */
export default function ProductPreview({ product, darkMode = false }) {
  if (!product?.name) return null;

  const GOLD = "#C9A961";
  const T = {
    text: darkMode ? "#F5F1EA" : "#1A1A1A",
    grey: darkMode ? "#A8A29A" : "#6B6560",
    divider: darkMode ? "#2E2A26" : "#E8E2D9",
    bg: darkMode ? "#1C1917" : "#FFFFFF",
  };

  // Feed images are the retailer's own CDN; a missing one renders text-only rather
  // than a broken frame.
  const href = product.url || "/shop";

  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      style={{
        display: "flex",
        gap: 12,
        alignItems: "stretch",
        textDecoration: "none",
        border: `1px solid ${T.divider}`,
        borderRadius: 8,
        overflow: "hidden",
        background: T.bg,
        marginBottom: 10,
      }}
    >
      {product.image && (
        <img
          src={product.image}
          alt={`${product.brand || ""} ${product.name}`.trim()}
          loading="lazy"
          style={{ width: 84, height: 100, objectFit: "cover", flexShrink: 0, display: "block" }}
        />
      )}
      <div style={{ padding: "10px 12px 10px 0", display: "flex", flexDirection: "column", gap: 3, minWidth: 0, justifyContent: "center" }}>
        <div style={{ fontSize: 8, fontFamily: "var(--font-body)", color: GOLD, letterSpacing: "0.12em", textTransform: "uppercase", opacity: 0.8 }}>
          The LWD Shop
        </div>
        {product.brand && (
          <div style={{ fontSize: 11, fontFamily: "var(--font-body)", color: T.grey, letterSpacing: "0.04em" }}>
            {product.brand}
          </div>
        )}
        <div
          style={{
            fontSize: 13,
            fontFamily: "var(--font-heading-primary)",
            color: T.text,
            lineHeight: 1.3,
            display: "-webkit-box",
            WebkitLineClamp: 2,
            WebkitBoxOrient: "vertical",
            overflow: "hidden",
          }}
        >
          {product.name}
        </div>
        {product.price && (
          <div style={{ fontSize: 12, fontFamily: "var(--font-body)", color: T.text, marginTop: 2 }}>
            {product.price}
          </div>
        )}
      </div>
    </a>
  );
}
